import { useSelector } from 'react-redux';

import { getHomePageTinyAccountId } from 'store/home';
import {
  getKitById,
  getResultsReadyKitForTinyAccountId,
} from 'store/kits';

import useGetKitIdParam from './useGetKitIdParam';

// Returns the kitId that top-level nav links (Results, Action Plan) should
// target. When the user is viewing a specific kit, nav links keep them on
// that kit; otherwise they default to the kit whose results are ready,
// falling back to the newest kit when none are ready.
export const useNavKitId = (): string | undefined => {
  const urlKitId = useGetKitIdParam();
  const homePageTinyAccountId = useSelector(getHomePageTinyAccountId);
  const urlKit = useSelector(getKitById(urlKitId));
  const tinyAccountId =
    urlKit?.tinyaccount_id ?? homePageTinyAccountId ?? null;
  const resultsReadyKitId = useSelector(
    getResultsReadyKitForTinyAccountId(tinyAccountId),
  )?.id;

  return urlKitId ?? resultsReadyKitId;
};

export default useNavKitId;
